// Selected league modules follow a linked player change (Ben, 2026-10-16, ?live=1 only).
//
// League Table, Match Results and Squad have no player of their own, so a linked pick
// (player-actions.ts) used to pass them by. Ben: on their own they stay put (like every
// module), but when they're SELECTED with player modules and the player changes, they
// switch to the new player's league (Match Results and Squad: also the player's club).
//
// This only marks them (`_followPlayer`) and rebuilds them; each module then opens on the
// new player's league from its own hooks (useStickyClub reads the sticky player, already
// the new one). The batch's single Undo checkpoint was taken before, with their old league.

/** The module titles that follow — they all rebuild from `_`-state on refresh (index.ts). */
export const LEAGUE_FOLLOW_TITLES: ReadonlySet<string> = new Set(["League Table", "Match Results", "Squad"]);

export function moduleTitleOf(mod: HTMLElement): string {
  return mod.querySelector<HTMLElement>(".module-title")?.innerText ?? "";
}

export function followsLeague(mod: HTMLElement): boolean {
  return LEAGUE_FOLLOW_TITLES.has(moduleTitleOf(mod));
}

/** Mark each league module among `targets` and rebuild it. */
export function followPlayerLeague(targets: readonly HTMLElement[], refreshModuleBody: (mod: HTMLElement) => void): void {
  for (const mod of targets.filter(followsLeague)) {
    (mod as unknown as { _followPlayer?: boolean })._followPlayer = true;
    refreshModuleBody(mod);
  }
}

/** The brief flash a selected module gets when it can't take the linked change. */
export function flashLinkSkipped(mod: HTMLElement): void {
  mod.classList.remove("link-skipped");
  void mod.offsetWidth; // restart the flash if it's still running
  mod.classList.add("link-skipped");
  mod.addEventListener("animationend", () => mod.classList.remove("link-skipped"), { once: true });
}
